export const KEY_CODE_MAPPING = {
  TAB: 9,
  ENTER: 13,
  SPACE_BAR: 32,
  ESCAPE: 27,
}
